import { Stack } from "@mantine/core";
import { PageHeader } from "components";
import PageContent from "components/layouts/PageContent";
import { FC } from "react";
import { PURCHASE_ORDER_PAGE } from "routes/route.constant";
import { PURCHASE_ORDER_PAGE_TITLE } from "../config";
import PurchaseOrderCreateForm from "./components/PurchaseOrderCreateForm/PurchaseOrderCreateForm";

const CreatePurchaseOrder: FC = () => {
  return (
    <Stack gap="sm">
      <PageHeader
        breadcrumbs={[
          { title: PURCHASE_ORDER_PAGE_TITLE, href: PURCHASE_ORDER_PAGE },
          { title: "Tạo đơn mua hàng", href: "" },
        ]}
      />
      <PageContent>
        <PurchaseOrderCreateForm />
      </PageContent>
    </Stack>
  );
};

export default CreatePurchaseOrder;
